exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding td{padding:0}#modal-call-alert .modal-header{padding:0;margin:0}.modal-header h5{margin:0!important;padding-top:0!important;padding-bottom:0!important}.modal-header-custom{display:flex;align-items:center;gap:8px}.modal-mypage-logo{width:133px;position:relative;left:20px}.incoming-call-media-controls .btn{min-width:130px}", ""]);

// exports
